<template>
  <div class="modal fade" id="countryAddModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered w-[700px]">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Add Country</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="overflow-hidden">
            <div class="float-left w-1/2 px-5 h-20 modal-item">
              Country Name:
              <v-text-field v-model="name" variant="outlined" density="compact"></v-text-field>
            </div>
            <div class="float-left w-1/2 px-5 h-20 modal-item">
              Order:
              <v-text-field v-model="order" type="number" variant="outlined" density="compact"></v-text-field>
            </div>
            <div class="float-left w-full px-5 h-20 modal-item">
              Flag URL (iconurl):
              <v-text-field v-model="iconurl" variant="outlined" density="compact"></v-text-field>
            </div>
            <div class="float-left w-full px-5 h-14 modal-item flex items-center">
              Sellable:
              <v-switch class="ml-4" v-model="sellable" color="success"></v-switch>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" :disabled="buttonDisableFlag" class="btn btn-primary" @click="handleCreate">
            Create
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from "vue";
import { useAdminCountryStore } from "@/stores";

const emit = defineEmits(["created"]);
const adminCountryStore = useAdminCountryStore();

const buttonDisableFlag = ref(false);
const name = ref("");
const iconurl = ref("");
const sellable = ref(true);
const order = ref(0);

const handleCreate = async () => {
  buttonDisableFlag.value = true;
  await adminCountryStore.createCountry({
    name: name.value,
    iconurl: iconurl.value,
    sellable: sellable.value,
    order: Number(order.value) || 0,
  });
  buttonDisableFlag.value = false;
  name.value = "";
  iconurl.value = "";
  sellable.value = true;
  order.value = 0;
  emit("created");
};
</script>

